var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ul',_vm._l((_vm.sectors),function(sector){return _c('li',{key:sector.id},[_vm._v(" "+_vm._s(_vm.$langobj.parse(sector))+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }